import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  getSideBarMenuData,
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      width: 0,
      height: 0,
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
  }


  componentDidMount() {
    if (this.props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
      this.props.onGetSideBarMenuData();
    }

    // Scroll Top to 0
    window.scrollTo(0, 0);

    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    }

    if (this.props.leftSideBarThemeImage) {
      this.props.changeSidebarThemeImage(this.props.leftSideBarThemeImage);
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sideBarMenuData !== this.props.sideBarMenuData) {
      this.setState({ sideBarMenuData: this.props.sideBarMenuData });
    }
  }

  toggleMenuCallback = () => {
    let body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  };

  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header toggleMenuCallback={this.toggleMenuCallback} />
          {this.props.loading ? (null
          ) : (
            <Sidebar
              theme={this.props.leftSideBarTheme}
              type={this.props.leftSideBarType}
              isMobile={this.state.isMobile}
              sideBarMenuData={this.props.sideBarMenuData}
            />
          )}

          <div className="main-content">{this.props.children}</div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.bool,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  sideBarMenuData: PropTypes.any,
  onGetSideBarMenuData: PropTypes.func,
  topbarTheme: PropTypes.any,
  loading: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    ...state.Layout,
    sideBarMenuData: state.Layout.sideBarMenuData,
    loading: state.Layout.loading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetSideBarMenuData: () => dispatch(getSideBarMenuData()),
    changeLayout: () => dispatch(changeLayout()),
    changeSidebarTheme: theme => dispatch(changeSidebarTheme(theme)),
    changeSidebarThemeImage: image => dispatch(changeSidebarThemeImage(image)),
    changeSidebarType: type => dispatch(changeSidebarType(type)),
    changeTopbarTheme: theme => dispatch(changeTopbarTheme(theme)),
    changeLayoutWidth: width => dispatch(changeLayoutWidth(width)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Layout));
